// Shell-wide operator counters.
//
// The topbar and the sidebar both want the same live numbers (events/min,
// sources up, open detections, ban suggestions awaiting review). Polling them
// from each component would double the round-trips, so the shell keeps one
// copy here: StatusBar owns the 15 s timer and calls `refreshShellStats()`;
// the Sidebar only reads.
//
// One request, not two: the pending-ban-suggestion count rides along in
// /api/v1/admin/stats rather than costing a separate list call every tick.
//
// `.svelte.ts` so the module-level `$state` is reactive across components.
// Errors are swallowed on purpose — a failed poll leaves the previous numbers
// on screen rather than blanking the chrome mid-investigation.

import { admin } from './api';
import type { AdminStats } from './types';

let _stats = $state<AdminStats | null>(null);
let _failed = $state(false);

export const shellStats = {
	get stats(): AdminStats | null {
		return _stats;
	},
	/** Ban suggestions awaiting review. Comes from the same payload — the
	 *  shell never spends a second request on it. */
	get pendingBans(): number | null {
		return _stats?.ban_suggestions_pending ?? null;
	},
	/** True when the most recent poll failed (numbers may be stale). */
	get failed(): boolean {
		return _failed;
	},
};

let _inflight = false;

export async function refreshShellStats(): Promise<void> {
	if (_inflight) return;
	_inflight = true;
	try {
		_stats = await admin.stats();
		_failed = false;
	} catch {
		_failed = true;
	} finally {
		_inflight = false;
	}
}

export function resetShellStats(): void {
	_stats = null;
	_failed = false;
}
